import { createFileRoute } from '@tanstack/react-router';
import TasksInboxPage from '@/pages/tasks/TasksInboxPage';
import { tasksSearchSchema } from '@/pages/tasks/search-schema';

export const Route = createFileRoute('/_authenticated/tasks/$taskId')({
  component: TasksInboxPage,
  validateSearch: tasksSearchSchema,
});
